<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('rw2-to-jpg-converter', 'Panasonic RW2 → JPG');

function handleBatchCreated(batchId: string) { console.log('[RW2 to JPG] Batch created:', batchId); }
function handleJobCompleted(jobId: string) { console.log('[RW2 to JPG] Job completed:', jobId); }
function handleBatchCleared() { console.log('[RW2 to JPG] Batch cleared'); }
function handleError(error: Error) { console.error('[RW2 to JPG] Error:', error); }
function handleCreditsUpdated(credits: number) { console.log('[RW2 to JPG] Credits updated:', credits); }
</script>
